/*jslint browser: true, vars: true, nomen: true, indent: 4, maxlen: 200, plusplus: true, sloppy: true, newcap: true, sub: true, regexp: true, continue: true, forin: true*/
/*global mdev: true, console: true, require: true, module: true*/
import api from '../api/loupan';
var $$model = require('assets/util/model.js');
var model = new $$model({});

var $$assert = require('assets/util/assert.js');

var _ = window._;

var model = new $$model({});

_.extend(model, {
    getLoupanKanfang: payload => api.loupanKanfangGet(payload),
    getEsfRecomdInfo: payload => api.getEsfRecomdInfo(payload),
    getPhoneQrcode: payload => api.getPhoneQrcode(payload),
    postLoupanKpbj: payload => api.postLoupanKpbj(payload),
    postLoupanKanfang: payload => api.postLoupanKanfang(payload),
    postLoupanBaoming: payload => api.postLoupanBaoming(payload),
    getVideoList: payload => api.getVideoList(payload),
    getVideoUrl: payload => api.getVideoUrl(payload),
    getMpAgentQrCode: payload => api.getMpAgentQrCode(payload),
    videoPlayCount: payload => api.videoPlayCount(payload),
    videoPlayCountIe: payload => api.videoPlayCountIe(payload),
    loupanListClueSend: payload => api.loupanListClueSend(payload),
    loupanClueSend: payload => api.loupanClueSend(payload),
    goodHouseSelector: payload => api.goodHouseSelector(payload),
});

module.exports = model;



// WEBPACK FOOTER //
// ./src/model/service/loupan.js